/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MediaBaseService } from '../media-base-service';
import { MediaApiConfiguration } from '../media-api-configuration';
import { MediaStrictHttpResponse } from '../media-strict-http-response';

import { categoryIdGet$Json } from '../fn/category/category-id-get-json';
import { CategoryIdGet$Json$Params } from '../fn/category/category-id-get-json';
import { categoryIdGet$Plain } from '../fn/category/category-id-get-plain';
import { CategoryIdGet$Plain$Params } from '../fn/category/category-id-get-plain';
import { CategoryModel } from '../models/category-model';
import { categoryPost$Json } from '../fn/category/category-post-json';
import { CategoryPost$Json$Params } from '../fn/category/category-post-json';
import { categoryPost$Plain } from '../fn/category/category-post-plain';
import { CategoryPost$Plain$Params } from '../fn/category/category-post-plain';
import { categorySearchCategoryPost$Json } from '../fn/category/category-search-category-post-json';
import { CategorySearchCategoryPost$Json$Params } from '../fn/category/category-search-category-post-json';
import { categorySearchCategoryPost$Plain } from '../fn/category/category-search-category-post-plain';
import { CategorySearchCategoryPost$Plain$Params } from '../fn/category/category-search-category-post-plain';
import { CategorySearchItemModelSearchResultModel } from '../models/category-search-item-model-search-result-model';

@Injectable({ providedIn: 'root' })
export class MediaCategoryService extends MediaBaseService {
  constructor(config: MediaApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `categorySearchCategoryPost()` */
  static readonly CategorySearchCategoryPostPath = '/Category/SearchCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorySearchCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  categorySearchCategoryPost$Plain$Response(params?: CategorySearchCategoryPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<CategorySearchItemModelSearchResultModel>> {
    return categorySearchCategoryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categorySearchCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  categorySearchCategoryPost$Plain(params?: CategorySearchCategoryPost$Plain$Params, context?: HttpContext): Observable<CategorySearchItemModelSearchResultModel> {
    return this.categorySearchCategoryPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<CategorySearchItemModelSearchResultModel>): CategorySearchItemModelSearchResultModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorySearchCategoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  categorySearchCategoryPost$Json$Response(params?: CategorySearchCategoryPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<CategorySearchItemModelSearchResultModel>> {
    return categorySearchCategoryPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categorySearchCategoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  categorySearchCategoryPost$Json(params?: CategorySearchCategoryPost$Json$Params, context?: HttpContext): Observable<CategorySearchItemModelSearchResultModel> {
    return this.categorySearchCategoryPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<CategorySearchItemModelSearchResultModel>): CategorySearchItemModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `categoryIdGet()` */
  static readonly CategoryIdGetPath = '/Category/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryIdGet$Plain$Response(params: CategoryIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<CategoryModel>> {
    return categoryIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryIdGet$Plain(params: CategoryIdGet$Plain$Params, context?: HttpContext): Observable<CategoryModel> {
    return this.categoryIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<CategoryModel>): CategoryModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryIdGet$Json$Response(params: CategoryIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<CategoryModel>> {
    return categoryIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryIdGet$Json(params: CategoryIdGet$Json$Params, context?: HttpContext): Observable<CategoryModel> {
    return this.categoryIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<CategoryModel>): CategoryModel => r.body)
    );
  }

  /** Path part for operation `categoryPost()` */
  static readonly CategoryPostPath = '/Category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  categoryPost$Plain$Response(params?: CategoryPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return categoryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  categoryPost$Plain(params?: CategoryPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.categoryPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  categoryPost$Json$Response(params?: CategoryPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return categoryPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  categoryPost$Json(params?: CategoryPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.categoryPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

}
